// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/ant-ling.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const ANT_LING_MODELS: ModelCatalog<typeof values, "ant-ling"> =
	flattenModelCatalog("ant-ling", values);
